function checkForSearchFlight() {
	if($("#fromAirport").val() == "" || $("#toAirport").val() == "") {
		alert(FmtMessage.getMessage('js.flight.search.empty.city.warning'));
		return;
	}

	if($("#fromAirportCity").val() && $("#fromAirportCity").val() ==  $("#toAirportCity").val()) {
    	alert(FmtMessage.getMessage('js.flight.search.warning'));
    	return;
    }

	var adult = $("#paxADT").val();
	var child = $("#paxCHD").val();
	var infant = $("#paxINF").val();
	
	var totalAdult = parseInt(adult);
	var totalPax = totalAdult + parseInt(child) + parseInt(infant);

	if (totalPax < 1) {
		alert(FmtMessage.getMessage('js.search.warning.1pax'));
	} else if (totalAdult < 1) {
		alert(FmtMessage.getMessage('js.search.warning.1adult'));
	} else if (totalAdult < infant) {
		alert(FmtMessage.getMessage('js.search.warning.infant.adult'));
	} else if (totalPax > 9) {
		alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), 9));
	} else {
		
		var spLocationName = $("#toAirport").val();
		var spLocationImg = $("#toAirportCity").val();
		$("#spLocationImg").attr("src", "/images/transit/explore/city/"+spLocationImg+".webp");
		$("#spLocationName").prepend(spLocationName);
		$('#flightLoading').modal('show');
		
		var formValid = $("#searchForm").valid();
		if (formValid) {
			var searchUrl = URL_MAPPING.resolveUrl('/searchFlights');
			document.searchForm.action = searchUrl;
			document.searchForm.submit();
		}
	}
}

var depFlights = [];
var retFlights = [];
var flightOpen2 = {};
var CONSTANT_NO_PENDING = 0;

$(document).ready(function(){
	
	if ($('#campaignSlider').length > 0) {
		var slider = tns({
		  container: '#campaignSlider',
		  controlsContainer: '#campaignControls',
		  prevButton: '.prev1',
		  nextButton: '.next1',
		  items: 1,
		  nav: false,
		  loop: false,
		  swipeAngle: false,
		  lazyload: true,
		  mouseDrag: true,
		  speed: 400,
		  gutter: 0,
		  responsive: {
		    900: {
		      items: 4,
		  	  gutter: 16,
		    }
		  }
		});
	}
	$( ".spinnerTravelerADT" ).spinner({
		min: 1,
		max: 6
	});
	$( ".spinnerTravelerCHD" ).spinner({
		min: 0,
		max: 4
	});
	$( ".spinnerTravelerINF" ).spinner({
		min: 0,
		max: 3
	});
	
	$(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").change(function(){
		  
		var paxADT = $( "[name=paxADT]" ).spinner( "value" );
		  var paxCHD = $( "[name=paxCHD]" ).spinner( "value" );
		  var paxINF = $( "[name=paxINF]" ).spinner( "value" );
		  
		  try {
			$.cookie('numAdultFlight', paxADT, { expires : 365, path : '/' });
			$.cookie('numChildFlight', paxCHD, { expires : 365, path : '/' });
		   	$.cookie('numInfantFlight', paxINF, { expires : 365, path : '/' });
		  } catch (e) {
		  }
		  
		  var totalPax = parseInt(paxADT) + parseInt(paxCHD) + parseInt(paxINF);
		  $(".travelerSelectPax").html(totalPax);
		  var locale = $.cookie('siteLocale');
		  if(locale == "en"){
			  if(totalPax > 1){
			  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.travelers'));
			  }else{
			  	$(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
			  }
		  }else if(locale == "ru" || locale == "uk"){
			  var partLast2 = totalPax % 100;
			  var partLast1 = totalPax % 10;
			  if(partLast1 == 0 || (partLast1 >= 5 && partLast1 <= 9) || (partLast2 >= 11 && partLast2 <= 14)){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru3'));
			  }else if(partLast1 == 1){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru1'));
			  }else if(partLast1 >= 2 && partLast1 <= 4){
				  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru2'));
			  }
		  }else{
			  $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
		  }
	});
	
	$(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").on("spinstop",function(){
		$(this).change();
	});

	$('input[name="departureDate"]').daterangepicker({
	  singleDatePicker: true,
      minDate: moment(),
      minYear: 2022,
	  maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
	  locale: {
	    format: 'DD.MM.YYYY'
	  }
	});
	
	$('input[name="returnDate"]').daterangepicker({
	  singleDatePicker: true,
      minDate: moment(),
      minYear: 2022,
	  maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
	  autoUpdateInput: false,
	  locale: {
	    format: 'DD.MM.YYYY'
	  }
	});

	$('input[name="departureDate"]').on('apply.daterangepicker', function(ev, picker) {
		var minDate = picker.startDate;
		var returnPicker = $('input[name="returnDate"]').data('daterangepicker');
		var returnDate = returnPicker.startDate;
		returnPicker.minDate = minDate;
		
		if ($('input[name="returnDate"]').val().trim().length > 0 && returnDate.isBefore(minDate)) {
			$('input[name="returnDate"]').val(minDate.add(1,'days').format('DD.MM.YYYY'));
			returnPicker.setStartDate(minDate);
			returnPicker.setEndDate(minDate);
			departurePicker.setStartDate(minDate.add(-1,'days'));
		}
	});
	$('input[name="returnDate"]').on('apply.daterangepicker', function(ev, picker) {
	  $(this).val(picker.startDate.format('DD.MM.YYYY'));
	  $('#clearReturning').show();
	  $('#returnCalendar').hide();
	});
	
	$('#clearReturning').click(function() {
	  $('input[name="returnDate"]').val('');
	  $('#clearReturning').hide();
	  $('#returnCalendar').show();
	});
	$('#btnradio1').click(function() {
		$('input[name="returnDate"]').val('');
		$('#clearReturning').hide();
  		$('#dateReturn').hide();
	});
	$('#btnradio2').click(function() {
	  	$('#clearReturning').show();
		$('#dateReturn').show();
	});

	
	$('input.people-count').on('change',function(){
		var pax = 0;
		$('input.people-count').each(function(idx,cbx){
			pax += parseInt($(cbx).val());
		});
		$('#people').val(pax + ' ' + FmtMessage.getMessage('js.passanger.type.traveler'));
	});
	$("[name=flightClass]").change(function(){
		var value = $(this).attr("data-attribute");
		
		if( value == 'ECONOMY' ){
            $('#selectClass option:selected').removeAttr('selected');
            $("#selectClass option[value='ECONOMY']").attr('selected', 'selected');
	  		$('.select-class .bi-check').addClass('d-none');
	  		$('.flightClass2 .bi-check').toggleClass('d-none');
	    } 
	    else if( value == 'BUSINESS' ){
            $('#selectClass option:selected').removeAttr('selected');
            $("#selectClass option[value='BUSINESS']").attr('selected', 'selected');
	  		$('.select-class .bi-check').addClass('d-none');
	  		$('.flightClass3 .bi-check').toggleClass('d-none');
	    } 
	    else {
            $('#selectClass option:selected').removeAttr('selected');
            $("#selectClass option[value='ALL']").attr('selected', 'selected');
            $('#selectClass option:selected').removeAttr('selected');
	  		$('.select-class .bi-check').addClass('d-none');
	  		$('.flightClass1 .bi-check').toggleClass('d-none');
	    }
		
		var id = this.id;
		var $label = $("[for=" + id + "]");
		$(".class-text").html($label.html());
	});
	
	$.ui.autocomplete.prototype._renderItem = function( ul, item){
		if (item.atype == 2) {
			ultext = "<a class='atype"+item.atype+"' >" + item.value + "</a>"; 
		    
		   	$( "<li></li>" ).data( "ui-autocomplete-item", item ).append( ultext).appendTo( ul );
		    
		    for(var i=0; i < item.airports.length;i++) {
		    	var airport = item.airports[i];
		    	
		    	ultext ="<a class='atype1'>" + airport.Name + " " +airport.Code + "</a></li>" ;
		    	
		    	$( "<li></li>" ).data( "ui-autocomplete-item", airport ).append( ultext).appendTo( ul );
		    }
		    return $( "<li></li>" );
		} else {
			// normal airport 
			ultext =  "<a class='' >" + item.value + "</a>" ;
			return $( "<li></li>" ).data( "ui-autocomplete-item", item ).append( ultext).appendTo( ul );
		}
	};
	
	$(".departures label.btn").on("click", function(){
	  var alertMsg = $(this).data("target");
	  $(".departures .rowcollapse").toggle(); 
	  $(alertMsg).show();
	  $("#resetBtn").removeClass( "d-none" ); 
	});
	$(".returns label.btn").on("click", function(){
	  var alertMsg = $(this).data("target");
	  $(".returns .rowcollapse").toggle(); 
	  $(alertMsg).show();
	});
	$( ".search-summary" ).click(function() {
	  $( ".change-search,.icon-search,.icon-close" ).toggleClass( "d-none" );
	  $(".modify-search").toggleClass( "btn-primary btn-danger" );
	});
	
	// mobile filter toggle
	$( ".btn-filter" ).click(function() {
	  $( "#collapseFilter" ).toggleClass( "d-none d-md-flex position-fixed top-0 start-0 bottom-0 end-0 z-3 p-2 overflow-auto bg-white" );
	  $( "#collapseFilter .accordion-body" ).toggleClass( "bg-light" );
	  $( ".close-text" ).toggleClass( "d-none" );
	});

	var autocompleteModal = new bootstrap.Modal(document.getElementById('autocompleteModal'), {})

	$('.btn-autocomplete-from').click(function() {
	  $('#fromAirport').appendTo('.mobile-autocomplete-input');
	  $('#toAirport').appendTo('.div-autocomplete-to');
	  $('#fromAirport').focus();
	  $('#fromAirport').select();
	  $('#autocompleteModal .btn-close').toggleClass('close-autocomplete');
	  $('#ui-id-1.ui-autocomplete').addClass("d-block");
	});
	$('.btn-autocomplete-to').click(function() {
	  $('#toAirport').appendTo('.mobile-autocomplete-input');
	  $('#fromAirport').appendTo('.div-autocomplete-from');
	  $('#toAirport').focus();
	  $('#toAirport').select();
	  $('#autocompleteModal .btn-close').toggleClass('close-autocomplete');
	  $('#ui-id-2.ui-autocomplete').addClass("d-block");
	});
	$('#autocompleteModal .btn-close').click(function() {
	  $('#fromAirport').appendTo('.div-autocomplete-from .input-group');
	  $('#toAirport').appendTo('.div-autocomplete-to .input-group');
	  $('#autocompleteModal .btn-close').removeClass('close-autocomplete');
	  $('.ui-autocomplete').removeClass("d-block");
	  autocompleteModal.hide();
	});
	
	$(".airportAutoComplete").autocomplete({
		source : function(request, response) {
			$.ajax({
				url : "/airports",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term
				},
				success : function(data) {
					response($.map(data.ResultSet.Result.slice(0,10), function(item) {
						return {
							value :  item.CityName + ", " + item.Name + " (" + item.Code + "), " + item.CountryCode,
							id : item.id,
							atype: item.type,
							name : item.Name,
							cityName: item.CityName,
							countryName: item.CountryName,
							countryCode : item.CountryCode,
							airports : item.airports,
							city : item.CityCode
						};
					}));
				}
			});
		},
		select : function(event, ui) {
			document.activeElement.blur();
			$('[name="' + $(this).attr('name') + 'Id"]', this.form).val(ui.item.id);
			if (ui.item.city) {
			  $('[name="' + $(this).attr('name') + 'City"]', this.form).val(ui.item.city);
			}else if (ui.item.CityCode) {
			  $('[name="' + $(this).attr('name') + 'City"]', this.form).val(ui.item.CityCode);
			}
			$(this).data('autoCompleteId', ui.item.id);
			var item = Object.assign({}, ui.item);
	        delete item['airports'];
			$.cookie($(this).attr('name'), JSON.stringify(item), { expires : 365, path : '/' });
			$('#fromAirport').appendTo('.div-autocomplete-from .input-group');
			$('#toAirport').appendTo('.div-autocomplete-to .input-group');
			$('#autocompleteModal .btn-close').removeClass('close-autocomplete');
			$('.ui-autocomplete').removeClass("d-block");
			autocompleteModal.hide();
		},
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    },
		minLength : 3
	}).change(function(event) {
		var itemId = $('[name="' + $(this).attr('name') + 'Id"]').val();
		var itemCity = $('[name="' + $(this).attr('name') + 'City"]').val();
	
		var item = {value: this.value, id: itemId, city:itemCity};
		$.cookie($(this).attr('name'), JSON.stringify(item), { expires : 365, path : '/' });
		$('#fromAirport').appendTo('.div-autocomplete-from .input-group');
		$('#toAirport').appendTo('.div-autocomplete-to .input-group');
		$('#autocompleteModal .btn-close').removeClass('close-autocomplete');
		$('.ui-autocomplete').removeClass("d-block");
		autocompleteModal.hide();
	});
	
	$(".airportAutoComplete").click(function() {
		$(this).select();
	});
	
	$(".setSelection").click(function() {
		$(this).focus();
		$(this).get(0).setSelectionRange(0,$(this).val().length);
	});
	
	// Start - Location set from Cookie
	if(!$('#fromAirport').val()){
		var itemJson = $.cookie('fromAirport', { path : '/' });
		if(itemJson){
			var item = JSON.parse(itemJson);
	
			if ('airports' in item){
				delete item['airports']
				var newItem = Object.assign({}, item);
	            $.cookie('fromAirport', JSON.stringify(newItem), { expires : 365, path : '/' });
	        }
	
			$('#fromAirport').val(item.value);
			$('[name="fromAirportId"]').val(item.id);
			if (item.city) {
				$('[name="fromAirportCity"]').val(item.city);
			}else if (item.CityCode) {
				$('[name="fromAirportCity"]').val(item.CityCode);
			}
		}
	}
	
	if(!$('#toAirport').val()){
		var itemJson = $.cookie('toAirport', { path : '/' });
		if(itemJson){
			var item = JSON.parse(itemJson);
	
	        if ('airports' in item){
	            delete item['airports']
	            var newItem = Object.assign({}, item);
	            $.cookie('toAirport', JSON.stringify(newItem), { expires : 365, path : '/' });
	        }
	
			$('#toAirport').val(item.value);
			$('[name="toAirportId"]').val(item.id);
			if (item.city) {
				$('[name="toAirportCity"]').val(item.city);
			}else if (item.CityCode) {
				$('[name="toAirportCity"]').val(item.CityCode);
			}
		}
	}
	// End - Location set from Cookie
	
	$('#loading').modal({
		show : false
	});
	depFlights = $("#depResults").find("div.result-row");
	departureMap = depFlights.map(function(){
		$this = $(this);
		return {
			row: $this.get(0),
			price: parseFloat($this.attr("price")),
			flighttime: parseFloat($this.attr("flighttime")),
			fdepdate: parseFloat($this.attr("fdepdate"))
		};
	});
	
	retFlights = $("#retResults").find("div.result-row");
	returnMap = retFlights.map(function(){
		$this = $(this);
		return {
			row: $this.get(0),
			price: parseFloat($this.attr("price")),
			flighttime: parseFloat($this.attr("flighttime")),
			fdepdate: parseFloat($this.attr("fdepdate"))
		};
	});
	
	
	// sorting cheapest / fastest
	$("input[name='sortingSearch']").change(function() {
	    if(this.checked) {
			var selected = $(this);
	        var attribute = $(selected).data("filter-attribute");
			var direction = $(selected).data("filter-direction");
	    }
		departureMap = sortFlightListTable($("#depResults"), departureMap, attribute, direction);
	});
	$("input[name='sortingSearchReturn']").change(function() {
	    if(this.checked) {
			var selected = $(this);
			var attribute = $(selected).data("filter-attribute");
			var direction = $(selected).data("filter-direction");
	    }
		returnMap = sortFlightListTable($("#retResults"), returnMap, attribute, direction);
	});
	
	$("#sortingSearch").change(function(){
		var selected = $(this).find('option:selected');
		var attribute = $(selected).data("filter-attribute");
		var direction = $(selected).data("filter-direction");
		
		departureMap = sortFlightListTable($("#depResults"), departureMap, attribute, direction);
	});
	
	$("#sortingSearchReturn").change(function(){
		var selected = $(this).find('option:selected');
		var attribute = $(selected).data("filter-attribute");
		var direction = $(selected).data("filter-direction");
		
		returnMap = sortFlightListTable($("#retResults"), returnMap, attribute, direction);
	});

	$(".departures label.btn").on("click", function(){
		var alertMsg = $(this).data("target");
		$(".departures .rowcollapse").toggle(); 
		$(alertMsg).show();
		$(".reset-dep-btn").removeClass( "d-none" ); 
	});
	$(".returns label.btn").on("click", function(){
		var alertMsg = $(this).data("target");
		$(".returns .rowcollapse").toggle(); 
		$(alertMsg).show();
		$(".reset-ret-btn").removeClass( "d-none" ); 
	});
	$(".reset-dep-btn,.reset-ret-btn").on("click", function(){
		$('html, body').animate({
			scrollTop: $('#priceDetailForm').offset().top
		}, 0);
	});

	
	$('input[name="d-radio"], input[name="r-radio"]').on('click',function(){
		$('.btnResetFilter').removeClass('opacity-0');
		var providerKey = $(this).attr("providerKey");
		var officeId = $(this).attr("officeId");
		var pendingType = $(this).attr("pendingType");

		if (checkTotalPax2(providerKey) > 0) {
			alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), checkTotalPax2(providerKey)));
			return false;
		}
			
		var flightType = $(this).attr("flightType");
		var $trs = flightType == 'departure' ? depFlights : retFlights;
		var index = $(this).attr("index");
								
		if(flightType == "departure"){
			$('#providerKeyDep').val(providerKey);
		}else{
			$('#providerKeyRet').val(providerKey);
		}

		flightOpen2[flightType] = false;

		$trs.not("[index=" + index + "]").hide();

		var other = flightType == "departure" ? "return" : "departure";
		var packageId = $(this).attr("packageId");
		var multiProviderEnabled = $(this).attr("multiProviderEnabled");
		var pricingType = $(this).attr("pricingType");
		
		var packageIdOther = Number($('[name='+(other == 'departure' ? 'd' : 'r')+'-radio]:checked').attr("packageId"));
		var providerKeyOther = $('[name='+(other == 'departure' ? 'd' : 'r')+'-radio]:checked').attr("providerKey");
		var multiProviderEnabledOther = $('[name='+(other == 'departure' ? 'd' : 'r')+'-radio]:checked').attr("multiProviderEnabled");
		var pricingTypeOther = $('[name='+(other == 'departure' ? 'd' : 'r')+'-radio]:checked').attr("pricingType");
		var officeIdOther = $('[name='+(other == 'departure' ? 'd' : 'r')+'-radio]:checked').attr("officeId");
		var pendingTypeOther = $('[name='+(other == 'departure' ? 'd' : 'r')+'-radio]:checked').attr("pendingType");

		var isProviderAndPendingTypeMatched = pendingType != CONSTANT_NO_PENDING && pendingType == pendingTypeOther && providerKey == providerKeyOther;
		var isProviderAndPackageAndPricingTypeMatched = (packageId == packageIdOther && providerKey == providerKeyOther && pricingType == pricingTypeOther);

		var samePackage = ((multiProviderEnabled == "true" && multiProviderEnabledOther == "true")
			|| isProviderAndPackageAndPricingTypeMatched)
			&& officeId == officeIdOther
			&& isProviderAndPendingTypeMatched;
			
		resetReturnPrices(other == "departure");
		
		var $selectedTr = $('div[index='+$(this).attr("index")+']');
		var comb = $selectedTr.data("comb");
		if (comb == null || comb == "") {
			if( flightOpen2[other] == undefined || flightOpen2[other] || !samePackage ){
				filterOtherFlights(providerKey, packageId, (other == "departure"), (multiProviderEnabled == "true"), pricingType, officeId, pendingType);
				flightOpen2[other] = true;
			}
		} else {
			if(flightType == "departure"){
				$("[name=r-radio]").attr('checked', false);								
			}
			filterCombinable($selectedTr, (other == "departure"));
			$trs.not("[index=" + index + "]").hide();							
		}
						
		if($('[name=d-radio]:checked').length == 1 && $('[name=r-radio]:checked').length == 1
			&& !$('[name=d-radio]:checked').is(":hidden") && !$('[name=r-radio]:checked').is(":hidden")){
			var packageIdDep = Number($('[name=d-radio]:checked').attr("packageId"));
			var packageIdRet = Number($('[name=r-radio]:checked').attr("packageId"));
			var providerKeyDep = $('[name=d-radio]:checked').attr("providerKey");
			var providerKeyRet = $('[name=r-radio]:checked').attr("providerKey");
			var pricingTypeDep = $('[name=d-radio]:checked').attr("pricingType");
			var pricingTypeRet = $('[name=r-radio]:checked').attr("pricingType");
	
			var providerIdDep = $('[name=d-radio]:checked').attr("providerid");
			var providerIdRet = $('[name=r-radio]:checked').attr("providerid");
			
			var $selectedTr = $('div[index='+$("[name=d-radio]:checked").attr("index")+']');
			var comb = $selectedTr.data("comb");
			if((comb != null && comb != "") ||
				(pricingTypeDep == pricingTypeRet && packageIdDep == packageIdRet && (packageIdDep == 0 || providerKeyDep == providerKeyRet))){
				
				var priceDep = parseFloat($('[name=d-radio]:checked').attr("price"));
				var priceRet = parseFloat($('[name=r-radio]:checked').attr("price"));
				var totalPrice = priceDep + priceRet;
				
				if(comb != null && comb != ""){
					totalPrice = priceRet*2;
				}
				
				if(providerIdDep == providerIdRet && providerKeyDep == providerKeyRet && pricingTypeDep == 'FREE_FORM'){
					var serviceFeeDep = parseFloat($('[name=d-radio]:checked').attr("servicefee"));
					var serviceFeeRet = parseFloat($('[name=r-radio]:checked').attr("servicefee"));
					var discount = (serviceFeeDep < serviceFeeRet ? serviceFeeDep : serviceFeeRet);
					
					if(discount > 0){
						$('#sameProviderTotalAmount').html(totalPrice.toFixed(2))
						$('#sameProviderDiscountAmount').html(-1*discount.toFixed(2))
						$('.totalDiscountText').show();
						totalPrice -= discount;
					}
					else{
						$('.totalDiscountText').hide();
					}
					
					
				}else{
					$('.totalDiscountText').hide();
				}
				$('#totalFareCont').html(totalPrice.toFixed(2));
				$('#continueButton').show();
			}else{
				$('#continueButton').hide();
			}
		}else{
			$('#continueButton').hide();
		}
		$('html, body').animate({
			scrollTop: $('#depResults').offset().top
		}, 0);
	});
	
	var $clickedButton = $();
	$(document).on("click",".priceDetailButton",function() {
		var $button = $clickedButton.length > 0 ? $clickedButton : $(this);

		if (!checkForPriceDeatil($button)) {
			alert(FmtMessage.getMessage('js.search.warning.infant') + "\n\n" + FmtMessage.getMessage('js.search.warning.child'));
		} else if (checkTotalPax($button) > 0) {
			alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), checkTotalPax($button)));
		} else if (isLastHourFlight($button)) {
			alert(FmtMessage.getMessage('js.search.warning.lastHourFlight'));
		} else {
			var spLocationName = $("#toAirport").val();
			var spLocationImg = $("#toAirportCity").val();
			$("#spLocationImg").attr("src", "/images/transit/explore/city/"+spLocationImg+".webp");
			$("#spLocationName").prepend(spLocationName);
			$('#loading').modal('show');
			$("#itinarary_departure").val($button.attr("segmentNames"));
			$("#officeId").val($button.attr("officeId"));

			var providerId = $button.attr("providerid");
			var flightDeparture = $button.attr("flightdeparture");
			var flightArrival = $button.attr("flightarrival");
			var faretype = $button.attr("faretype");

			setProvidersPassengers(providerId, flightDeparture, flightArrival, faretype);

			$("#priceDetailForm").submit();
			return true;
		}
	});
		
	$(document).on("click",".priceDetailButtonCont",function() {
		var $depButton = $('[name=d-radio]:checked');
		var $retButton = $('[name=r-radio]:checked');

		if ($('[name=r-radio]').length == 0) {
			if (!checkForPriceDeatil($depButton)) {
				alert(FmtMessage.getMessage('js.search.warning.infant') + "\n\n" + FmtMessage.getMessage('js.search.warning.child'));
			} else if (checkTotalPax($depButton) > 0) {
				alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), checkTotalPax($button)));
			} else if (isLastHourFlight($depButton)) {
				alert(FmtMessage.getMessage('js.search.warning.lastHourFlight'));
			} else {
				var spLocationName = $("#toAirport").val();
				var spLocationImg = $("#toAirportCity").val();
				$("#spLocationImg").attr("src", "/images/transit/explore/city/"+spLocationImg+".webp");
				$("#spLocationName").prepend(spLocationName);
				$('#loading').modal('show');
				$("#itinarary_departure").val($depButton.val());
				$("#officeId").val($depButton.attr("officeId"));
	
				var providerId = $depButton.attr("providerid");
				var flightDeparture = $depButton.attr("flightdeparture");
				var flightArrival = $depButton.attr("flightarrival");
				var faretype = $depButton.attr("faretype");
	
				setProvidersPassengers(providerId, flightDeparture, flightArrival, faretype);
	
				$("#priceDetailForm").submit();
				return true;
			}
		} else if (checkAllPriceDetails($depButton, $retButton)) {
			var spLocationName = $("#toAirport").val();
			var spLocationImg = $("#toAirportCity").val();
			$("#spLocationImg").attr("src", "/images/transit/explore/city/"+spLocationImg+".webp");
			$("#spLocationName").prepend(spLocationName);
			$('#loading').modal('show');
			$("#itinarary_departure").val($depButton.val());
			$("#itinarary_return").val($retButton.val());

			var providerId = $depButton.attr("providerid");
			var flightDeparture = $depButton.attr("flightdeparture");
			var flightArrival = $depButton.attr("flightarrival");
			var rProviderId = $depButton.attr("providerid");
			var rFlightDeparture = $retButton.attr("flightdeparture");
			var rFlightArrival = $retButton.attr("flightarrival");

			var faretype = $depButton.attr("faretype");
			var rFaretype = $retButton.attr("faretype");

			if(providerId == rProviderId || setProvidersPassengers(providerId, flightDeparture, flightArrival, faretype) && 
					!setProvidersPassengers(rProviderId, rFlightDeparture, rFlightArrival, rFaretype)){
				setProvidersPassengers(providerId, flightDeparture, flightArrival, faretype);
			}else if(!setProvidersPassengers(providerId, flightDeparture, flightArrival, faretype) && 
				setProvidersPassengers(rProviderId, rFlightDeparture, rFlightArrival, rFaretype)){
					setProvidersPassengers(rProviderId, rFlightDeparture, rFlightArrival, rFaretype);
			}
			var officeId = $depButton.attr("officeId");
			$("#officeId").val(officeId);
			
			$("#priceDetailForm").submit();
			return true;
		}
	});

	$(".js-range-slider-time").ionRangeSlider({
	    type: "double",
	    skin: "round",
	    hide_min_max: true,
	    hide_from_to: true,
	    postfix: ":00",
	    onChange: function (data) {
			$('#'+data.input[0].id+'Input').val(data.from + ':00 - ' + data.to + ':00');
			applyFilter();
	    }
	});
	
	$(".js-range-slider-travel").ionRangeSlider({
	    type: "double",
	    skin: "round",
	    hide_min_max: true,
	    hide_from_to: true,
	    postfix: "hr",
	    onChange: function (data) {
			$('#'+data.input[0].id+'Input').val(data.from + 'hr - ' + data.to + 'hr');
			applyFilter();
	    }
	});
	$('.placeholder-glow,.loading-results').hide();
});

function checkForPriceDeatil($button) {
	var adult = $("#numAdult").val();
	var child = $("#numChild").val();
	var infant = $("#numInfant").val();

	var totalPax = parseInt(adult) + parseInt(child) + parseInt(infant);

	var cntNonFlyingAloneINF = 0;
	var cntNonFlyingAlonePax = 0;

	var providerId = $button.attr("providerid");
	var flightdeparture = $button.attr("flightdeparture");
	var flightarrival = $button.attr("flightarrival");
	var faretype = $button.attr("faretype");

	if(providerDefMap[providerId] == null)
		setProvidersPassengers(providerId, flightdeparture, flightarrival, faretype);
	
	if(providerDefMap[providerId] != null){
		
		if (!providerDefMap[providerId].isChildFlyingAlone)
			cntNonFlyingAlonePax = parseInt(cntNonFlyingAlonePax) + parseInt(child);
		
		if (!providerDefMap[providerId].isInfantFlyingAlone)
			cntNonFlyingAloneINF = parseInt(cntNonFlyingAloneINF) + parseInt(infant);

	} else { // For general case, Adult/Child/Infant
		cntNonFlyingAlonePax = parseInt(child);
		cntNonFlyingAloneINF = parseInt(infant);
	}

	if (parseInt(cntNonFlyingAloneINF) > (totalPax - cntNonFlyingAlonePax - cntNonFlyingAloneINF))
		return false;

	if (cntNonFlyingAlonePax > 0 && (totalPax - cntNonFlyingAloneINF - cntNonFlyingAlonePax) < 1)
		return false;

	return true;
}

function checkTotalPax($button) {
	var providerKey = $button.attr("providerKey");

	var adult = $("#numAdult").val() !== undefined ? parseInt($("#numAdult").val()) : 0;
	var child = $("#numChild").val() !== undefined ? parseInt($("#numChild").val()) : 0;
	var infant = $("#numInfant").val() !== undefined ? parseInt($("#numInfant").val()) : 0;
	
	var totalPax = adult + child + infant;
	var paxLimit = 9;
	if (providerKey == 'TravelFusion') {
		paxLimit = 4;
	}else if (providerKey == 'THY' || providerKey == 'THY DOM' || providerKey == 'THY B2C') {
		paxLimit = 7;
	}
	if (totalPax > paxLimit)
		return paxLimit;
	else
		return 0;
}

//Dönüş uçuşlarının fiyatları paket uçuşlarda gidiş seçildiğinde pakete göre tekrar önyüzde hesaplandığından bu fonksiyona ihtiyaç var
function resetReturnPrices(isSelectedReturn){
	if(isSelectedReturn) return;
	
	$('div.results').find('#priceTextNumber').each(function(index) {
		var retPriceStr = $(this).closest('div.result-row').attr("price");
		var fltPrice = parseFloat(retPriceStr).toFixed(2);
		var currency = $.cookie("currency");
		$(this).html(fltPrice+" "+currency);
	});	
	
}

function filterCombinable($selectedTr, isSelectedReturn) {
	var comb = $selectedTr.data("comb");
	if (comb == null || comb == "") {
		return;
	}
	
	var $list;
	if(isSelectedReturn){
		$list = depFlights.filter(":not(:hidden)");
	} else {
		$list = retFlights.filter(":not(:hidden)");
	
	}
	var selectedPrice = parseFloat($selectedTr.attr("price"));

	$list.each(function(index){
		var itinId = $(this).attr("flightId");
		
		if (comb.indexOf(itinId) < 0) {
			$(this).hide();
		} else {
			$(this).show();
			if(!isSelectedReturn){
				var retPrice = parseFloat($(this).attr("price"));
				var retPriceForCombinedFlights = retPrice*2-selectedPrice; // Paket uçuşlarda müşteriden dönüş uçuşunun iki katı ücret alınır. Ancak listede dönüş fiyatı gösterirken iki katından gidiş fiyatı düşüyoruz
				
				var fltPrice = parseFloat(retPriceForCombinedFlights).toFixed(2);
				var currency = $.cookie("currency");
				$(this).find('#priceTextNumber').html(fltPrice.toString()+" "+currency);
			}				
		}		
	});
}

function filterOtherFlights(providerKey, packageId, departure, multiProviderEnabled, pricingType, officeId, pendingType) {
	$('#contraryProviderWarning').hide();
	var $trs = flightType == 'departure' ? depFlights : retFlights;

	var $inputs = $('[name="' + (departure ? 'd' : 'r') + '-radio"]');
	var $inputsp = {};
	if (multiProviderEnabled && pendingType == CONSTANT_NO_PENDING){
		$inputsp = $inputs.filter('[multiProviderEnabled=true][officeId=' + officeId + '][pendingType="' + pendingType + '"]');
	}
	else if(multiProviderEnabled)
		$inputsp = $inputs.filter('[multiProviderEnabled=true][officeId=' + officeId + '][providerKey="' + providerKey + '"][pendingType="' + pendingType + '"]');
	else
		$inputsp = $inputs.filter('[providerKey="' + providerKey + '"][packageId="' + packageId + '"][pricingType="' + pricingType + '"][officeId="' + officeId + '"]');
	
	var $inputsn = $inputs.not($inputsp);
	$inputsn.each(function(index) {
		var attrIndex = $(this).attr("index");
		$trs.filter("[index=" + attrIndex + "]").hide();
		
		if(departure){
			//$flightListDep.filter("[index=" + attrIndex + "]").next().andSelf().attr("data-visible","false");
			depFlights.filter("[index=" + attrIndex + "]").hide();
		} else {
			//$flightListRet.filter("[index=" + attrIndex + "]").next().andSelf().attr("data-visible","false");
			retFlights.filter("[index=" + attrIndex + "]").hide();
		}
	});
}

function checkAllPriceDetails($dButton, $rButton){
	if (!checkForPriceDeatil2($dButton) || !checkForPriceDeatil2($rButton)) {
		alert(FmtMessage.getMessage('js.search.warning.infant') + "\n\n" + FmtMessage.getMessage('js.search.warning.child'));
		return false;
	} else if (checkTotalPax2($dButton.attr("providerKey")) > 0) {
		alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), checkTotalPax2($dButton.attr("providerKey"))));
		return false;
	} else if (checkTotalPax2($rButton.attr("providerKey")) > 0) {
		alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), checkTotalPax2($rButton.attr("providerKey"))));
		return false;
	} else if ($('input[name=direction]:checked').val() == 2 && !checkReturnFlightTime2($dButton, $rButton)) {
		alert(FmtMessage.getMessage('js.search.warning.returnFlightDeparture'));
		return false;
	} else if (isLastHourFlight($dButton)) {
		alert(FmtMessage.getMessage('js.search.warning.lastHourFlight'));
		return false;
	}
	return true;
}

function checkForPriceDeatil2($button) {
	var adult = $("#numAdult").val();
	var child = $("#numChild").val();
	var infant = $("#numInfant").val();

	var totalPax = parseInt(adult) + parseInt(child) + parseInt(infant);

	var cntNonFlyingAloneINF = 0;
	var cntNonFlyingAlonePax = 0;

	var providerId = $button.attr("providerid");
	var flightdeparture = $button.attr("flightdeparture");
	var flightarrival = $button.attr("flightarrival");

	var faretype = $button.attr("faretype");
	
	if(setProvidersPassengers(providerId, flightdeparture, flightarrival, faretype)){
		if(providerDefMap[providerId] != null){
			if (!providerDefMap[providerId].isChildFlyingAlone)
				cntNonFlyingAlonePax = parseInt(cntNonFlyingAlonePax) + parseInt(child);
			
			if (!providerDefMap[providerId].isInfantFlyingAlone)
				cntNonFlyingAloneINF = parseInt(cntNonFlyingAloneINF) + parseInt(infant);
		}
	} else {
		cntNonFlyingAlonePax = parseInt(child);
		cntNonFlyingAloneINF = parseInt(infant);
	};

	if (parseInt(cntNonFlyingAloneINF) > (totalPax - cntNonFlyingAlonePax - cntNonFlyingAloneINF))
		return false;

	if (cntNonFlyingAlonePax > 0 && (totalPax - cntNonFlyingAloneINF - cntNonFlyingAlonePax) < 1)
		return false;

	return true;
}

function checkTotalPax2(providerKey) {
	var adult = $("#numAdult").val() !== undefined ? parseInt($("#numAdult").val()) : 0;
	var child = $("#numChild").val() !== undefined ? parseInt($("#numChild").val()) : 0;
	var infant = $("#numInfant").val() !== undefined ? parseInt($("#numInfant").val()) : 0;

	var totalPax = adult + child + infant;

	var paxLimit = 9;
	if (providerKey == 'TravelFusion') {
		paxLimit = 4;
	}else if (providerKey == 'THY' || providerKey == 'THY DOM' || providerKey == 'THY B2C') {
		paxLimit = 7;
	}
	if (totalPax > paxLimit)
		return paxLimit;
	else
		return 0;
}

function isLastHourFlight($button) {
	var departureDate = parseTRDate($button.attr("firstlegdeparture"));
	var now = new Date();
	var anHourLater = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours()+1, now.getMinutes());
	
	if (departureDate < anHourLater)
		return true;
	else
		return false;
}

function checkReturnFlightTime2($dButton, $rButton) {
	var departureFlightArrival = parseTRDate($dButton.attr("lastLegArrival"));
	var returnFlightDeparture = parseTRDate($rButton.attr("firstLegDeparture"));

	if (returnFlightDeparture <= departureFlightArrival) {
		return false;
	} else {
		return true;
	}
}

function parseTRDate(dateString) {
	var parts = dateString.split(' ');
	var dateParts = parts[0].split('.');
	var timeParts = parts[1].split(':');

	var date = new Date(dateParts[2], parseInt(dateParts[1], 10) - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2]);

	return date;
}
function sortFlightListTable(table, mapFlight, attribute, direction){
	//sortList
	var swapped = true;
	while (swapped) {
		swapped = false;
		for(var i = 0, j = 1; i < mapFlight.length - 1; i++,j++){
			var result = mapFlight[i][attribute] > mapFlight[j][attribute] ? 1 : (mapFlight[i][attribute] < mapFlight[j][attribute] ? -1 : 0);
			if(direction == "desc"){
				result *= -1;
			}
			
			if(result == 1){
				swapped = true;
				var temp = mapFlight[i];
				mapFlight[i] = mapFlight[j];
				mapFlight[j] = temp;
			}
		}
	}
	
	mapFlight.each(function(){
		table.append(this.row);		
	});
	
	return mapFlight;
}

function switchAirports() {
	var fromAirport = $("[name=fromAirport]").val();
	var toAirport = $("[name=toAirport]").val();
	var fromAirportId = $("[name=fromAirportId]").val();
	var toAirportId = $("[name=toAirportId]").val();
	var fromAirportCity = $("[name=fromAirportCity]").val();
	var toAirportCity = $("[name=toAirportCity]").val();
	$("[name=fromAirport]").val(toAirport);
	$("[name=toAirport]").val(fromAirport);
	$("[name=fromAirportId]").val(toAirportId);
	$("[name=toAirportId]").val(fromAirportId);
	$("[name=fromAirportCity]").val(toAirportCity);
	$("[name=toAirportCity]").val(fromAirportCity);
}
function resetSearchFilter(){
	$('.btnResetFilter').addClass('opacity-0');
	$('#reset-btn').addClass('d-none');
	$('input.filterByTransfer').prop('checked',true);
	$('input.searchFilterAirline').prop('checked',true);
	$('input.searchClassFilter').prop('checked',true);
	
	$('.js-range-slider-time').each(function(){
		var sliderData = $(this).data("ionRangeSlider");
		sliderData.update({
			from : 0,
			to : 24
		});
		$('#'+sliderData.input.id+'Input').val('00:00 - 24:00');
	});
	
	$('.js-range-slider-travel').each(function(){
		var sliderData = $(this).data("ionRangeSlider");
		sliderData.update({
			from : 1,
			to : 48
		});
		$('#'+sliderData.input.id+'Input').val('1hr - 48hr');
	});
	
	applySearchFilter();
}

function applyFilter(){
	$('.btnResetFilter').removeClass('opacity-0');
	applySearchFilter();
}

function applySearchFilter(){
	depFlights.show();
	
	if (!$('#filterByTransfer0').is(':checked')) {
		depFlights.filter("[tranferCount='0']").hide();
	}
	
	if (!$('#filterByTransfer1').is(':checked')) {
		depFlights.filter("[tranferCount='1']").hide();
	}
	
	if (!$('#filterByTransfer2').is(':checked')) {
		depFlights.filter("[tranferCount='2']").hide();
	}
	
	retFlights.show();
	
	if (!$('#filterByReturnTransfer0').is(':checked')) {
		retFlights.filter("[tranferCount='0']").hide();
	}
	
	if (!$('#filterByReturnTransfer1').is(':checked')) {
		retFlights.filter("[tranferCount='1']").hide();
	}
	
	if (!$('#filterByReturnTransfer2').is(':checked')) {
		retFlights.filter("[tranferCount='2']").hide();
	}

	$("input.searchFilterAirline:not(:checked)").each(function(index) {
		depFlights.filter("[airlinename='" + $(this).val() + "']").hide();
		retFlights.filter("[airlinename='" + $(this).val() + "']").hide();
	});
	
	var depDeparture = $("#depDepartureTimes").data();
	filterSliderDepTime(depFlights, depDeparture.from, depDeparture.to);
	
	var retDeparture = $("#retDepartureTimes").data();
	if (retDeparture != null) {
		filterSliderDepTime(retFlights, retDeparture.from, retDeparture.to);
	}
	
	var depArrival = $("#depArrivalTimes").data();
	filterSliderArrTime(depFlights, depArrival.from, depArrival.to);
	
	var retArrival = $("#retArrivalTimes").data();
	if (retArrival != null) {
		filterSliderArrTime(retFlights, retArrival.from, retArrival.to);
	}
	
	var depTravel = $("#depTravelTimes").data();
	filterSliderTravelTimes(depFlights, depTravel.from, depTravel.to);
	
	var retTravel = $("#retTravelTimes").data();
	if (retTravel != null) {
		filterSliderTravelTimes(retFlights, retTravel.from, retTravel.to);
	}

	$("input.searchClassFilter:not(:checked)").each(function(index) {
		depFlights.filter("[faretype='" + $(this).val() + "']").hide();
		retFlights.filter("[faretype='" + $(this).val() + "']").hide();
	});
	
	$("input.depBaggageAllowance:not(:checked)").each(function(index) {
		var baggageAmount = $(this).attr("baggageAmount");
		var baggageType = $(this).attr("baggageType");
		depFlights.filter("[baggageAmount='" + baggageAmount + "'][baggageType='" + baggageType + "']").hide();
	});

	$("input.retBaggageAllowance:not(:checked)").each(function(index) {
		var baggageAmount = $(this).attr("baggageAmount");
		var baggageType = $(this).attr("baggageType");
		retFlights.filter("[baggageAmount='" + baggageAmount + "'][baggageType='" + baggageType + "']").hide();
	});
}

function filterSliderDepTime(flightList, minHour, maxHour) {
	flightList.each(filterSliderDepTimeList(minHour, maxHour));	
}

function filterSliderDepTimeList(minHour, maxHour) {
	return function(index){
		var fdepdate = parseInt($(this).attr("fdepdate").substring(0,2));
	
		if(!isNaN(fdepdate) && fdepdate == 0)
			fdepdate = parseInt($(this).attr("fdepdate").substring(1,2));
		
		if(!isNaN(fdepdate)) {
			
			var chkMinute = parseInt($(this).attr("fdepdate").substring(3,5));									//check minute
			if(chkMinute > 0 && fdepdate < parseInt(minHour - 1) || fdepdate > parseInt(maxHour + 1)) {			//check minute
				$(this).hide();
			} else if(fdepdate < parseInt(minHour) || fdepdate > parseInt(maxHour)) {
				$(this).hide();
			}
		}
	}
}

function filterSliderArrTime(flightList, minHour, maxHour) {
	flightList.each(filterSliderArrTimeList(minHour, maxHour));	
}

function filterSliderArrTimeList(minHour, maxHour) {
	return function(index){
		var fdepdate = parseInt($(this).attr("farrdate").substring(0,2));
	
		if(!isNaN(fdepdate) && fdepdate == 0)
			fdepdate = parseInt($(this).attr("farrdate").substring(1,2));
		
		if(!isNaN(fdepdate)) {
			
			var chkMinute = parseInt($(this).attr("farrdate").substring(3,5));									//check minute
			if(chkMinute > 0 && fdepdate < parseInt(minHour - 1) || fdepdate > parseInt(maxHour + 1)) {			//check minute
				$(this).hide();
			} else if(fdepdate < parseInt(minHour) || fdepdate > parseInt(maxHour)) {
				$(this).hide();
			}
		}
	}
}

function filterSliderTravelTimes(flightList, minHour, maxHour) {
	flightList.each(filterSliderTravelTimesList(minHour, maxHour));
}

function filterSliderTravelTimesList(minTime, maxTime) {
	return function(index){
		if(!($(this).attr("flighttime") >= minTime && $(this).attr("flighttime") <= maxTime)){
			$(this).hide();
		}
	}
}

function searchAnotherDay(dep, ret) {
	$("#dayDep").val(dep);
	$("#dayRet").val(ret);
	$('#loading').modal('show');
	$("#searchForm").submit();
}

function searchAirlines() {
	
	var input, filter, li, a, i;
    input = document.getElementById("searchAirlines");
    filter = input.value.toUpperCase();
    li = document.getElementsByClassName("airline-check");
    for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByClassName("airline-name")[0];
        if (a.innerHTML.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
        } else {
            li[i].style.display = "none";
        }
    }
	$('#resetSearchAirline').removeClass("d-none");
	
	if( !input.value ) {
		$('#resetSearchAirline').addClass("d-none");
	}
	
}

function resetSearchAirline(){
	
    input = document.getElementById("searchAirlines");
	input.value = "";
	$('.airline-check').css("display","flex");
	
	$('#resetSearchAirline').addClass("d-none");
	
}
function unselectAllFilterAirline() {
	$('.searchFilterAirline').prop('checked', false);

	$('#resetFilterAirline').removeClass("d-none");
	applyFilter();
}
function resetFilterAirline() {
	$('.searchFilterAirline').prop('checked', true);
	
	$('#resetFilterAirline').addClass("d-none");
	resetSearchAirline();
	applyFilter();
}

